var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11950",
    transform: "translate(-675 -475.175)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 340",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(675 475.175)",
    style: {
      fill: "#59ffb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5356",
    d: "M0 0h18v18H0z",
    style: {
      fill: "none"
    },
    transform: "translate(681 481.175)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5357",
    d: "M695.965 482.719h-11.93a1.5 1.5 0 0 0-1.491 1.491v8.948a1.5 1.5 0 0 0 1.491 1.491h10.439l2.983 2.983V484.21a1.5 1.5 0 0 0-1.492-1.491zm-1.491 8.948h-8.947v-1.492h8.947zm0-2.237h-8.947v-1.492h8.947zm0-2.237h-8.947v-1.491h8.947z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.66c25ba9427831a666bef61f5e1ce976.svg";
export { ForwardRef as ReactComponent };